import React, { useEffect, useState } from 'react';
import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';

import useQuery from '~/app/shared/hooks/useQuery';
import useCachedQuery from '~/app/shared/hooks/useCachedQuery';
import { Account } from '~/app/pages/accounting/bank/accounts/types';
import { AddModal } from '~/app/pages/accounting/bank/accounts/components/modals/AddModal';
import { addBankAccount, mapBankAccount } from '~/app/pages/accounting/bank/accounts/utils';
import { BankDto, PaymentAccountWithIntegrationCurrencyDto } from '~/types/internal-api';
import { useSignupDialogOnboardingContext } from '../../../contexts/SignupDialogOnboardingContextProvider';
import { useSignupDialogForm } from '../../../hooks/useSignupDialogForm';

const AddBankAccountDialogButton = () => {
    const { refetchBankAccounts } = useSignupDialogOnboardingContext();
    const { updateFormData } = useSignupDialogForm();

    const [accounts, setAccounts] = useState<Account[]>([]);

    const { data: dataAccounts, loading: loadingAccounts } = useQuery<PaymentAccountWithIntegrationCurrencyDto[]>(
        '/paymentAccounts/accounts-with-integration-currency',
        []
    );
    const { data: banks } = useCachedQuery<BankDto[]>(`/smartbank/banks-collection`, []);

    useEffect(() => {
        if (!loadingAccounts) {
            const mappedData: Account[] = mapBankAccount(dataAccounts);

            setAccounts(mappedData);
        }
    }, [loadingAccounts]);

    const addAccount = async (account: Account) => {
        const addedAccount = await addBankAccount(account);
        await refetchBankAccounts();

        // use newly added account number as selected option
        updateFormData({ bankAccount: addedAccount.number });
    };

    return (
        <Button
            appearance="discrete"
            dialog={dialogProps => (
                <AddModal
                    onClose={() => {}}
                    addAccount={addAccount}
                    accounts={accounts}
                    banks={banks}
                    skipNotifications={false}
                    autoclose
                    {...dialogProps}
                />
            )}>
            <Trans>Add bank account</Trans>
        </Button>
    );
};

export default AddBankAccountDialogButton;
